import { render, staticRenderFns } from "./new-paycheck.vue?vue&type=template&id=2ab507fc&"
import script from "./new-paycheck.vue?vue&type=script&lang=js&"
export * from "./new-paycheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports